import { useLocation, useNavigate } from 'react-router-dom';
import { assetUrl } from '#/utils/assetUrl';
import {
  getIsAndroidInAppWebView,
  getIsInApp,
} from '#/domains/landing/utils/inApp';
import { ctaLinkProps } from '#/domains/landing/utils/ctaLink';
import { DEEPLINK_APP_ENTRY } from '#/constants/deeplinks';

interface NavBarProps {
  hideBackButton?: boolean;
}

export default function NavBar({ hideBackButton = false }: NavBarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const isInApp = getIsInApp();
  // Android in-app webview has its own system back; the web back arrow is redundant.
  const isAndroidInAppWebView = getIsAndroidInAppWebView();
  const { href: deeplinkHref } = ctaLinkProps(DEEPLINK_APP_ENTRY);

  // Override hideBackButton when the user navigated here from within the SPA.
  // React Router sets location.key !== 'default' on in-app navigations, so we
  // can safely surface the back arrow.
  const navigatedFromWithinApp = location.key !== 'default';
  const showBackButton =
    !isAndroidInAppWebView && (!hideBackButton || navigatedFromWithinApp);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate('/');
  };

  return (
    <nav className="fixed inset-x-0 top-0 z-[100] flex h-[76px] items-center border-b border-[color:var(--color-border)] bg-white/95 pt-[env(safe-area-inset-top)] backdrop-blur-[8px]">
      <div className="flex w-full items-center justify-between px-6">
        <div className="flex items-center">
          {!isInApp && showBackButton && (
            <button
              type="button"
              className="-ml-3 cursor-pointer p-3 active:opacity-60"
              aria-label="Go back"
              onClick={handleBack}
            >
              <img
                src={assetUrl('/icon-back.svg')}
                alt=""
                width={24}
                height={24}
              />
            </button>
          )}
        </div>
        {!isInApp && (
          <a
            href={deeplinkHref}
            className="inline-flex h-11 min-w-[116px] items-center justify-center whitespace-nowrap rounded-xl bg-blue-55 px-6 text-sm font-bold text-white transition-colors hover:bg-[#3358e6]"
            style={{ WebkitTapHighlightColor: 'transparent' }}
          >
            앱에서 확인하기
          </a>
        )}
      </div>
    </nav>
  );
}
